import { isAdmin } from "@common/auth/session";
import BannerEditor from "../components/admin/BannerEditor";
import Deploys from "../components/admin/Deploys";
import Lambdas from "../components/admin/Lambdas";
import Members from "../components/admin/Members";
import Tables from "../components/admin/Tables";
import RequireAuth from "../components/RequireAuth";
import type { Session } from "../hooks/useSession";

export default function AdminPage({ session }: { session: Session }) {
  const { user, signIn } = session;
  return (
    <main className="page admin">
      <h1>Admin</h1>
      <RequireAuth user={user} onSignIn={signIn}>
        {user && isAdmin(user) ? (
          <>
            <BannerEditor />
            <Members me={user.sub} />
            <Tables />
            <Deploys />
            <Lambdas />
          </>
        ) : (
          <p className="muted">
            This page is for Salvagers admins. If you were just made one, sign out and back in so your sign-in picks it
            up.
          </p>
        )}
      </RequireAuth>
    </main>
  );
}
